import { type LoaderFunctionArgs } from "react-router";

import {
  DashboardProjectsDocumentsDetailsDocument,
  type DashboardProjectsDocumentsDetailsQuery,
  type DashboardProjectsDocumentsDetailsQueryVariables,
} from "@app_schema";

import { client } from "@application/config/apollo";

export const DASHBOARD_PROJECTS_DOCUMENTS_DETAILS_LOADER = async (
  props: LoaderFunctionArgs,
) => {
  const { id: projectID, documentID } = props.params;
  if (!projectID) throw new Error("undefined projectID");
  if (!documentID) throw new Error("undefined documentID");

  const { data } = await client.query<
    DashboardProjectsDocumentsDetailsQuery,
    DashboardProjectsDocumentsDetailsQueryVariables
  >({
    query: DashboardProjectsDocumentsDetailsDocument,
    variables: {
      projectID,
      documentID,
    },
  });

  return data;
};
